import React from "react";

import { components } from "react-select";

import type { MultiValueRemoveProps } from "react-select";

import { DenovoIcon } from "../../icons";
import { IOption } from "../interfaces";

export const MultiValueRemove: React.FC<MultiValueRemoveProps<IOption>> = (
  props,
) => {
  return (
    <components.MultiValueRemove {...props}>
      <DenovoIcon icon="clear" />
    </components.MultiValueRemove>
  );
};
